<template>
  <div>
    <div class="bus-header">
      <div class="top-logo" @click="goHome()">
        <img alt="logo" :src="filePath + logoPath">
        <span>{{companyname}}</span>
      </div>
      <div class="busstype-name">{{busstypeName}}</div>
      <div class="busstype-content">
        <pre>{{busstypeContent}}</pre>
      </div>
      <span class="back-home">回到首页</span>
    </div>
    <router-view/>
    <app-footer v-if="footer_show" :token="token"></app-footer>
  </div>
</template>
<script>
import Vue from 'vue'
import { Tab, Tabs } from 'vant'
import Footer from '../../components/Footer'
import { fetchPost } from '../../utils/axiosfunc.js'

Vue.use(Tab)
Vue.use(Tabs)
export default {
  data () {
    return {
      token: this.$cookies.get('token'),
      logoPath: '',
      companyname: '',
      busstypeName: '业务办理',
      busstypeContent: '尊敬的用户\n请选择您所需办理的业务',
      footer_show: true
    }
  },
  components: {
    'app-footer': Footer
  },
  created () {
    const logoPath = this.$cookies.get('logoPath')
    if (logoPath == null) {
      const reqRrl = '/client/api/mp.do'
      const params = {
        token: this.$cookies.get('token')
      }
      // 初始数据
      fetchPost('/mobilebus' + reqRrl, params).then(response => {
        const data = JSON.parse(response.request.response)
        this.datas = data.data
        if (data.code === 200) {
          this.logoPath = data.data.logoPath
          this.companyname = data.data.companyname
          this.$cookies.set('logoPath', this.logoPath, '30d')
          this.$cookies.set('companyname', this.companyname, '30d')
        }
      })
    } else {
      this.logoPath = logoPath
      this.companyname = this.$cookies.get('companyname')
    }
  },
  methods: {
    // 是否显示底部
    footer: function (bool) {
      this.footer_show = bool
    },
    changeBusstypeText (busstypeName, busstypeContent) {
      this.busstypeName = busstypeName
      this.busstypeContent = busstypeContent
    },
    goHome () {
      this.$router.push({
        path: '/index/home',
        query: {
          token: this.$cookies.get('token')
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
  /deep/.zsy-logo-div2 {
    margin-bottom: 30px;
  }
  .bus-header {
    position: relative;
    background-color: #008ACB;
    min-height: 130px;
    padding-bottom: 15px;
  }
  .top-logo {
    position: relative;
    padding-top: 10px;
    margin-left: 5px;
    margin-bottom: 5px;
    color: #fff;
    vertical-align: middle;
    z-index: 999;
  }
  .top-logo img {
    display: inline-block;
    margin-right: 5px;
    width: 30px;
    border-radius: 50%;
    line-height: 36px;
    vertical-align: middle;
    background-color: #fff;
  }
  .top-logo span {
    font-size: 15px;
    font-weight: bold;
    line-height: 36px;
    vertical-align: middle;
  }
  .busstype-name {
    color: rgb(255, 255, 255);
    font-size: 20px;
    margin-left: 42px;
  }
  .busstype-content {
    color: rgb(255, 255, 255);
    font-size: 14px;
    line-height: 24px;
    margin-left: 42px;
    margin-top: 5px;
    margin-right: 10px;
  }
  .back-home {
    position: absolute;
    top: 25px;
    right: 10px;
    color: rgb(255, 255, 255);
    font-size: 14px;
  }
</style>
